import { Box, HTMLChakraProps, Text } from '@chakra-ui/react';
import { FC, Fragment } from 'react';

import { LectureSearchCardPopover } from '@/components/ui/shared/lecture/LectureSearchCard/components/LectureSearchCardPopover';
import { HighlightedResults } from '@/components/ui/shared/search/HighlightedResults';
import { ILectureHighlightedResults } from '@/resources/ThinLecture';
import { ThinProfile } from '@/resources/ThinProfile';

import {
  getHighlightedSpeakerFullName,
  sortSpeakersByMatchValueComparator,
  getSpeakerFullName,
} from '../LectureSearchCard.utils';

interface ILectureCardAuthorsProps extends HTMLChakraProps<'div'> {
  noOfLines: number;
  highlightedResults?: ILectureHighlightedResults;
  data?: Array<ThinProfile>;
  href?: string;
}

export const LectureSearchCardAuthors: FC<ILectureCardAuthorsProps> = ({
  data,
  noOfLines,
  highlightedResults,
  href,
  ...rest
}) => {
  const resultComponent = highlightedResults?.speakers ? (
    <HighlightedResults
      data={highlightedResults.speakers}
      sort={sortSpeakersByMatchValueComparator}
      getValue={getHighlightedSpeakerFullName}
    />
  ) : (
    <Fragment>{data.map(getSpeakerFullName).join(', ')}</Fragment>
  );

  return (
    <Box w="full" as="a" href={href} zIndex="2!important" {...rest}>
      <LectureSearchCardPopover
        isDisabled={Boolean(!data.length)}
        bodySlot={<Text textStyle="plexBody">{resultComponent}</Text>}
        triggerSlot={
          <Text textStyle="plexBody" noOfLines={noOfLines}>
            {resultComponent}
          </Text>
        }
      />
    </Box>
  );
};
